import { CurrencyTextField } from "@/common/components/CurrencyTextField"
import { formatCurrency } from "@/common/utils/formatters"
import { PrivateCompanyLeadsFunnelUpdateValidationSchema } from "@/features/privateCompanyLeadsFunnel/schemas/update.schema"
import { FinancialInformationData } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead"
import { BaseSyntheticEvent } from "react"
import { Control, Controller, FieldErrors } from "react-hook-form"

interface FinancialInformationSectionProps {
  financial_information?: FinancialInformationData
  control: Control<PrivateCompanyLeadsFunnelUpdateValidationSchema, any>
  errors: FieldErrors<PrivateCompanyLeadsFunnelUpdateValidationSchema>
  submit?: (e?: BaseSyntheticEvent) => Promise<void>
}

export const FinancialInformationSection = ({
  financial_information,
  control,
  errors,
  submit,
}: FinancialInformationSectionProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <p className="text-[18px] font-bold">Dados Financeiros <span className="text-sm font-light italic">(Substituirá os dados de expectativa como aprovados)</span></p>
      </div>
      <Controller
        name="financial_information_attributes.approved_credit"
        control={control}
        defaultValue={financial_information?.approved_credit ? formatCurrency(financial_information?.approved_credit) : undefined}
        render={({ field }) => (
          <CurrencyTextField
            label="Crédito Aprovado"
            markAsRequired
            allowZero
            maxValue={999_999_999.99}
            className="w-full"
            {...field}
            onBlur={() => submit?.()}
            errorMessage={errors.financial_information_attributes?.approved_credit?.message || undefined}
          />
        )}
      />
    </div>
  )
}
